import slugify from "slugify";
/**
 * The shape of a slug that can be used as part of a content
 * URL i.e. /article/<slug>
 */
export const SLUG_PATTERN = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;
export const MAX_SLUG_LENGTH = 120;
/**
 * Turns any input (user input, a filename, a title) into a slug
 * that is safe to use as part of a URL.
 */
export function normalizeSlug(value) {
    if (!value) {
        return "";
    }
    return slugify(value.trim().toLowerCase(), { strict: true })
        .slice(0, MAX_SLUG_LENGTH)
        .replace(/^-+|-+$/g, "");
}
export function isValidSlug(value) {
    return !!value && value.length <= MAX_SLUG_LENGTH && SLUG_PATTERN.test(value);
}
